export default __webpack_public_path__ + "static/media/omatietovaranto.bcd2440b.png";